import { render, staticRenderFns } from "./PrivacyTabPolicy.vue?vue&type=template&id=a12e5f90"
import script from "./PrivacyTabPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyTabPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports